import { useEffect } from "react";
import { Node } from "prosemirror-model";

import versionStore from "@app/state/store/report-document/version";
import documentStore from "@app/state/store/report-document/document";

import { diffMerge } from "../lib/content-diff";
import { getVersionedTableCaptions } from "../diff-utility";

export const useDiff = ({ editor, left, right, sectionId, hasLoaded }) => {
    useEffect(() => {
        if (editor && left && right && hasLoaded) {
            const iRight = getVersionedTableCaptions(left, right);

            const docOld = Node.fromJSON(editor.schema, left).toJSON();
            const docNew = Node.fromJSON(editor.schema, iRight).toJSON();

            if (!docNew.content) {
                docNew.content = [];
            }

            const mergedDoc = diffMerge(docOld, docNew);

            editor.commands.setContent(mergedDoc);
            versionStore.updateChangeCounter();

            const content = editor.getJSON();
            documentStore.processSection(sectionId, content);
        }
    }, [editor, left, right, hasLoaded]);
};

export default useDiff;
